<template>
  <ag-modal-container
    :title="$t('tokens.title.createDemands')"
    width="900px"
    @close="back"
  >
    <ask-tokens-form
      v-model="value"
      @validate="isValid = $event"
    />

    <template v-slot:footer>
      <v-spacer />
      <v-btn
        :disabled="loading"
        color="primary"
        class="ml-5"
        outlined
        @click="back"
        v-text="$t('general.cancel')"
      />
      <v-btn
        :loading="loading"
        :disabled="!isValid || loading"
        color="accent"
        class="ml-5"
        @click="submit"
        v-text="$t('general.validate')"
      />
    </template>
  </ag-modal-container>
</template>

<script>
import { mapActions } from 'vuex'
import Repositories from 'src/repositories'

import AgModalContainer from 'src/components/common/AgModalContainer'
import AskTokensForm from '../components/AskTokensForm'

export default {
  name: 'TokensAskContainer',
  components: {
    AgModalContainer,
    AskTokensForm,
  },
  data: () => ({
    isValid: false,
    loading: false,
    value: {
      tokenNumber: null,
      comment: '',
    },
  }),
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    back () {
      this.$router.back()
    },
    async submit () {
      this.loading = true
      try {
        await Repositories.myCompany.sendAction('tokenDemand', this.value)
        this.showSuccessNotification(this.$t('tokens.demands.success'))
        this.$router.replace('/tokens/demands')
      }
      catch (error) {
        const notification = Repositories.parseErrorMessage(error)
        this.showErrorNotification(notification)
      }
      finally {
        this.loading = false
      }
    },
  },
}
</script>
